export enum ReviewPlatformIdentifier {
  GOOGLE_MY_BUSINESS = "GOOGLE-MY-BUSINESS",
  FACEBOOK = "FACEBOOK",
  YELP = "YELP",
  TRIPADVISOR = "TRIPADVISOR",
  ZOMATO = "ZOMATO",
  CARS = "CARS",
  TRUSTPILOT = "TRUSTPILOT",
}

export interface Review {
  userId: string;
  id: string;
  businessId: string;
  channel: ReviewPlatformIdentifier;
  rating: number;
  review: string;
  reviewTitle: string;
  datetime: Date;
  responded: boolean;
}
